module.exports = __webpack_public_path__ + "static/media/6.55a912c6.JPG";